<template>
  <div class="registro-wrapper">
    <v-app-bar app fixed color="white" elevation="2" height="70">
      <v-container
        class="d-flex align-center justify-space-between main-container"
      >
        <a href="#inicio" class="logo text-decoration-none d-flex align-center">
          <v-img
            src="../../public/logo.webp"
            max-height="64"
            max-width="150"
            contain
          ></v-img>
        </a>

        <span class="primary--text text-h4 font-weight-bold d-none d-sm-block"
          >Tokia Play</span
        >
      </v-container>
    </v-app-bar>

    <div class="content-wrapper">
      <v-container class="fill-height">
        <v-row align="center" justify="center">
          <v-col cols="12" lg="10" xl="9">
            <v-card
              color="#FFFFFF"
              class="main-card elevation-8"
              style="border-radius: 16px;"
            >
              <v-card-text class="pa-6 pa-md-8">
                <div class="row justify-content-center">
                  <div class="col-md-6">
                    <h3
                      style="color:#1E0E62; font-size: 40px;line-height: 1.2; margin-bottom: 1rem;"
                    >
                      Bienvenido al Registro de Complejo Deportivo en
                      <strong>Tokia Play!</strong>
                    </h3>
                    <p
                      class="mb-5"
                      style="font-size: 16px; line-height: 1.5; color: rgba(21, 20, 57, 0.4)"
                    >
                      Complete todos los datos del formulario para registrar su
                      complejo, se enviará un correo electrónico al E-mail que
                      indique en su registro con todas las indicaciones.
                    </p>
                    <v-form
                      class="mb-4"
                      ref="form"
                      v-model="valid"
                      :lazy-validation="lazy"
                    >
                      <v-row dense class="mb-4">
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="nombre"
                            outlined
                            placeholder="Nombres"
                            maxlength="80"
                            label="Nombres"
                            dense
                            :rules="requiredRules"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="apellido"
                            outlined
                            label="Apellidos"
                            placeholder="Apellidos"
                            maxlength="80"
                            dense
                            :rules="requiredRules"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            v-model="nombreInstitucion"
                            outlined
                            label="Nombre del Complejo"
                            placeholder="Nombre del Complejo"
                            hint="Será utilizado también para generar su portal del jugador personalizado"
                            persistent-hint
                            maxlength="100"
                            dense
                            :rules="requiredRules"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="mail"
                            placeholder="E-mail"
                            outlined
                            label="E-mail"
                            :rules="emailRules"
                            dense
                            maxlength="80"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="celular"
                            outlined
                            label="Celular"
                            placeholder="Celular"
                            maxlength="80"
                            dense
                            :rules="requiredRules"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-select
                            :items="itemsPais"
                            item-text="nombrePais"
                            item-value="idPais"
                            placeholder="País"
                            label="País"
                            dense
                            outlined
                            v-model="pais"
                            :rules="requiredRules"
                          >
                          </v-select>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <span
                            style="color: #1E0E62; font-size: 1rem; font-weight: 700;"
                          >
                            Web Portal del Jugador:
                          </span>
                          <span
                            style="color: rgba(21, 20, 57, 0.4); font-size: 1rem; font-weight: 700;"
                            >{{
                              nombreInstitucion
                                ? urlWeb
                                : "Ingrese el nombre del complejo primero"
                            }}</span
                          >
                        </v-col>
                      </v-row>
                    </v-form>
                    <v-card-actions
                      style="padding: 0; display: flex; justify-content: space-between; align-items: flex-end; flex-wrap: wrap; gap: 1rem; margin-top: 2rem;"
                    >
                      <v-btn
                        color="#F7941D"
                        :disabled="!valid"
                        @click.stop="registrarme"
                        style="border-radius: 10px; color: white; text-transform: none;height: 50px;width: 210px; box-shadow: none;"
                        >Registrarme</v-btn
                      >

                      <a
                        class="back-link"
                        @click="salir"
                        style="font-size: 14px; color: rgba(21, 20, 57, 0.4); cursor: pointer;"
                        >Volver a Tokia Play</a
                      >
                    </v-card-actions>
                  </div>
                  <div style="width: 100%" class="col-md-6">
                    <v-alert
                      style="font-size: 21px; line-height: 1.6; border-radius: 12px;"
                      color="#1E0E62"
                      dark
                    >
                      Una vez finalizado el registro, te mostraremos aquí mismo
                      cómo ingresar al sistema junto con tus credenciales de
                      acceso. Estos datos también serán enviados al correo
                      electrónico que indiques durante el registro.<br /><br />
                      Al ingresar, podrás cambiar tu contraseña, la cual habrá
                      sido generada automáticamente. También vas a poder
                      configurar tus canchas adicionales, con sus días y
                      horarios de atención, así como la duración de los turnos,
                      que pueden variar según el día. Gestioná tus clases,
                      profesores, ligas, torneos y mucho más!<br /><br />
                      Te recomendamos que nos contactes para conocer todas las
                      funcionalidades (¡son muchísimas!) y darte soporte para
                      realizar las configuraciones iniciales.<br /><br />
                      ¡Esperamos que disfrutes la experiencia!
                    </v-alert>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import axios from "../axios-auth.js";
import router from "../router/index.js";

export default {
  data: (vm) => ({
    valid: false,
    lazy: false,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
    emailRules: [
      (v) =>
        !v ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "E-mail inválido",
      (v) => !!v || "Dato obligatorio",
    ],
    nombre: null,
    apellido: null,
    nombreInstitucion: "",
    celular: null,
    mail: null,
    itemsPais: [],
    pais: null,
    matricula: null,
  }),
  computed: {
    sufijoUrl() {
      return this.generarNombreUrl(this.nombreInstitucion);
    },
    urlWeb() {
      return `https://jugador.tokiaplay.com/portal/${this.sufijoUrl}`;
    },
  },
  methods: {
    salir() {
      router.push("/");
    },
    generarNombreUrl(nombre) {
      return nombre
        .replace(/\s+/g, " ")
        .trim()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join("")
        .slice(0, 50);
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      }
    },
    registrarme() {
      this.$swal({
        title: "Registrar Complejo",
        text: "¿Desea registrar el complejo?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then(async (result) => {
        if (result.value) {
          let self = this;
          const datosUsuario = {
            nombre: this.nombre,
            apellido: this.apellido,
            nombreInstitucion: this.nombreInstitucion,
            mail: this.mail,
            celular: this.celular,
            matricula: this.matricula,
            idPais: this.pais,
            url: this.urlWeb,
            sufijoUrl: this.sufijoUrl,
          };
          axios
            .post("/Institucional/RegUsu", datosUsuario)
            .then((response) => {
              if (response.data.estadoRegistro == true) {
                self.showAlert({
                  icon: "success",
                  title: "Complejo registrado exitosamente!",
                  vm: self,
                });
                setTimeout(function() {
                  self.guardarNombreUsuPass(
                    response.data.usuario,
                    response.data.clave,
                  );
                  self.vaciarModels();
                  router.push("/RegistroExitoso");
                }, 2700);
              } else {
                self.showAlert({
                  icon: "error",
                  title:
                    "El complejo no pudo ser registrado. Intente nuevamente más tarde",
                  vm: self,
                });
              }
            })
            .catch((error) => {
              self.showAlert({
                icon: "error",
                title:
                  "El complejo no pudo ser registrado. Intente nuevamente más tarde",
                vm: self,
              });
            });
        }
      });
    },
    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 2000,
      });
    },
    vaciarModels() {
      this.nombre = null;
      this.apellido = null;
      this.nombreInstitucion = "";
      this.celular = null;
      this.mail = null;
      this.pais = null;
      this.matricula = null;
    },
    guardarNombreUsuPass(usuario, clave) {
      this.$store.dispatch("guardarNombreUsuClave", {
        nombre: this.nombre + " " + this.apellido,
        usuario: usuario,
        clave: clave,
      });
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: "smooth" });
    let self = this;
    axios
      .get("/Institucional/DamePaises")
      .then((response) => {
        self.itemsPais = response.data;
      })
      .catch((error) => {});
  },
};
</script>

<style scoped>
.registro-wrapper {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.content-wrapper {
  min-height: 100vh;
  display: flex;
  align-items: center;
  padding-top: 70px; /* Altura del header */
  padding-bottom: 2rem;
}

.main-container {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  max-width: 100%;
}

.main-card {
  width: 100%;
  max-width: 100%;
}

/* Para pantallas pequeñas */
@media (max-width: 959px) {
  .content-wrapper {
    padding-top: 90px;
    padding-bottom: 1rem;
  }
}

@media (max-width: 599px) {
  .content-wrapper {
    padding-top: 100px;
  }

  .primary--text.text-h4 {
    font-size: 1.5rem !important;
  }
}
</style>
